import { Navigate, useNavigate } from "react-router-dom";
import React, { useCallback, useContext } from "react";
import { signOut } from "../../firebase";
import { InfoBox } from "./info-box";
import { AuthContext } from "./auth-provider";

export const VerifyEmail = () => {
  const navigate = useNavigate();
  const user = useContext(AuthContext);

  const handleContinue = useCallback(() => {
    user
      ?.getIdToken(true)
      .then(() => user?.reload())
      .then(() => navigate("/"));
  }, [user, navigate]);

  if (user && !user?.emailVerified) {
    return (
      <div className="food xs:mt-16 xs:rounded shadow-xl mx-auto p-4 xs:max-w-sm">
        <InfoBox>
          Verifieer nu je email adres door op de link in je mail te klikken,
          wanneer je email adres is geverifieerd, klik dan op 'Doorgaan' om
          verder te gaan.
        </InfoBox>
        <button onClick={handleContinue} className="btn-primary mb-6">
          <i className="fa fa-sign-in-alt mr-2 fa-2x" />
          <span>Doorgaan</span>
        </button>
        <button onClick={signOut} className="btn-secondary mb-6">
          <i className="fa fa-power-off mr-2 fa-2x" />
          <span>Terug</span>
        </button>
      </div>
    );
  } else {
    return <Navigate to={"/login"} />;
  }
};
